import pro1 from "../assets/project1.JPG";
import pro2 from "../assets/project2.JPG";
import pro3 from "../assets/project3.JPG";
import pro4 from "../assets/project4.JPG";

const ProjectCardData = [
    {
        imgsrc: pro4,
        title: "How We Scaled Our Newsletter to 1,100 Subscribers in 8 Weeks—And Why Japanese Beetle Control Needs Reinventing",
        text: "If you’ve been there—you’re not alone. We’ve been there too. That’s why we’re committed to building the most-effective Japanese Beetle solution on the market.",
        view: "https://www.youtube.com/watch?v=P8YuWEkTeuE",
        path: '/blog/newsletter-april-recap'
    },
    {
        imgsrc: pro1,
        title: "Summer 2024 Research Recap",
        text: "Here is a quick recap of our first research pilot this summer as we work towards EPA registration. Check it out for our top learnings and more.",
        view: "https://www.youtube.com/watch?v=P8YuWEkTeuE",
        path: '/blog/summer-2023-research-recap'
    },
    {
        imgsrc: pro2,
        title: "Top 5 Lessons from MN Cup",
        text: "Alure LLC was the STUDENT DIVISION WINNER of the Minnesota Cup in 2024! The funding we received will be used to continue our research, manufacturing, and development of this innovation.",
        view: "https://www.youtube.com/watch?v=P8YuWEkTeuE",
        path: '/blog/top-5-lessons-mn-cup'
    },
    {
        imgsrc: pro3,
        title: "Product Manufacturing Research Underway!",
        text: "To gear up for future scaling, we have already identified and are working with a textile manufacturer to create a small batch this summer for research. Read on to learn more about the product development process.",
        view: "https://www.youtube.com/watch?v=P8YuWEkTeuE",
        path: '/blog/product-manufacturing-underway'
    },
]

export default ProjectCardData;